import { render, staticRenderFns } from "./UserManagementEdit.vue?vue&type=template&id=138be7a4&scoped=true&"
import script from "./UserManagementEdit.vue?vue&type=script&lang=js&"
export * from "./UserManagementEdit.vue?vue&type=script&lang=js&"
import style0 from "./UserManagementEdit.vue?vue&type=style&index=0&id=138be7a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138be7a4",
  null
  
)

export default component.exports